module.exports = __webpack_public_path__ + "img/banner_left.5b6cf8ef.png";